module.exports = __webpack_public_path__ + "img/undraw_Sharing_articles_re_jnkp.7bf77c64.svg";